'use client';

import React from 'react';
import Image from 'next/image';
import useMediaQuery from '@/hooks/useMediaQuery';

import css from './DesktopPadding.module.css';

export const DesktopPadding = () => {
	const isMobile = useMediaQuery('(max-width: 500px)', true);

	if (isMobile) return null;

	return (
		<div className={css.root}>
			<div className={css.background}>
				<Image
					className={css.illustration}
					width={685}
					height={431}
					src="/images/rv-camping-illustration.svg"
					alt="rv camping illustration"
				/>
			</div>
		</div>
	);
};
